import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxAddonComponent } from './phx-addon.component';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    CommonModule,
    PhxDropdownModule,
    PhxIconModule
  ],
  declarations: [PhxAddonComponent],
  exports: [PhxAddonComponent]
})
export class PhxAddonModule { }
